<template>
  <div>
    <b-row class="match-height">
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0">
            Informações do Exame
          </h4>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="gradient-success"
            @click="showModal"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
            />
            <span>Adicionar Exames</span>
          </b-button>
        </div>
        
        <b-card class="mb-2">
          <b-list-group flush>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="CalendarIcon"
                  class="mr-50"
                />
                <span>Data do Exame</span>
              </div>
              <span class="font-weight-bolder">{{ formatHyphenToSlash(exame.dataExame) }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="UserIcon"
                  class="mr-50"
                />
                <span>Profissional</span>
              </div>
              <span class="font-weight-bolder">{{ exame.profissional.nome }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <feather-icon
                  icon="BriefcaseIcon"
                  class="mr-50"
                />
                <span>Especialidade</span>
              </div>
              <b-badge variant="light-primary">
                {{ exame.especialidade.descricao }}
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-form-group
          label="Observações"
          label-for="exame-observacoes"
        >
          <b-form-textarea
            id="exame-observacoes"
            v-model="exame.observacao"
            placeholder="Digite as observações do exame"
            rows="3"
            :disabled="disableFormObs"
          />
        </b-form-group>
      </b-col>
            <ButtonsFormVue
            label-edit="Editar Observação"
            label-save="Salvar Observação"
            :disable-form="disableFormObs"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvarObservacao"
            @edit="editObservacao"
            @cancel="beforeCancelarObservacao"
          />
      <b-col cols="12">
        <hr/>
      </b-col>
    </b-row>
    <validation-observer ref="exameForm">
      <b-form @submit.prevent>
        <app-collapse
          v-for="exameItem in exame.exames"
          :key="exameItem.id"
          type="margin"
          border
        >
          <app-collapse-item
            :isVisible="true"
            :title="exameItem.exame"
          
          >          
            <b-row>
              <b-col cols="12">
              <div class="justify-content-end d-flex flex-wrap">
                  <b-button
                    class="mb-3"
                    variant="outline-danger"
                    @click="deleteExame(exameItem)"
                  >
                    <feather-icon icon="Trash2Icon" />
                    Deletar
                  </b-button>
                </div>
              </b-col>
             <b-col cols="12">
              <label for="textarea-default">Resultado</label>
              <b-form-textarea
                id="textarea-default"
                v-model="exameItem.resultado"
                placeholder="Textarea"
                rows="3"
                :disabled="disableForm"
              />
            </b-col>
            </b-row>
          </app-collapse-item>
        </app-collapse>
          <ButtonsFormVue
          v-if="exame.exames.length > 0"
            label-edit="Editar Resultados"
            label-save="Salvar Resultados"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
         
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal ref="my-modal" hide-footer>
      <div class="d-block text-center">
        <h3>Requisição para Exames</h3>
        <b-row>
          <!-- situacaoRegistro -->
          <b-col ols="12" lg="12">
            <b-form-group label="Selecione os exames" label-for="v-situacao">
              <v-select
                v-model="examesSelected"
                label="label"
                :options="comboExames"
                multiple
                rule
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="col-12 mt-1"
          variant="outline-primary"
          block
          :disabled="!examesSelected"
          @click="showMsgBoxCreate"
        >
          Continua
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="col-12 mt-1"
          variant="outline-danger"
          block
          @click="hideModal"
        >
          Cancelar
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,

} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue"
import mixinsGlobal from "@/mixins";
import vSelect from "vue-select";
export default {
  props: {
    exameProp: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinsGlobal],
  components: {
    AppCollapse,
    AppCollapseItem,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
    vSelect,
  },
  data() {
    return {
      examesSelected: [],
      showExameForm: false,
      loading: false,
      disableForm: true,
      disableFormObs: true,
      exame: {
        id: null,
        registro: {
          id: null,
          nome: "",
        },
        especialidade: {
          id: null,
          descricao: "",
          tipoAtendimento: {
            id: null,
            descricao: "",
          },
        },
        atendimento: null,
        observacao: null,
        dataExame: null,
        tipoExameEspecifico: null,
        eg: null,
        dispneia: false,
        cianose: false,
        palidez: false,
        edema: false,
        ictericia: false,
        pulso: false,
        turgenc: false,
        outros: false,
        detOutro: null,
        auscNormal: false,
        auscAlterada: false,
        detAusc: null,
        ausccardRc: null,
        ausccardFc: null,
        pa: null,
        mmhg: null,
        outrosPa: false,
        detOutroPa: null,
      },
      comboExames: [
     { label: "teste 1", value: 105 },
     { label: "teste 2", value: 106 },
     { label: "teste 3", value: 107 },
   ],
    };
  },
  watch: {
    exameProp: {
      handler(newVal) {
        if (newVal) {
          this.setExame(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    salvarObservacao() {
      this.$store
        .dispatch("exameModule/editObservacao", this.exame)
        .then((response) => {
          this.disableFormObs = false;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar exames:", error);
          this.loading = false;
        });
      
    },
    editObservacao() {
      this.disableFormObs = false;
    },
    beforeCancelarObservacao() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair do cadastro do exame?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelarObservacao();
          }
        });
    },
    cancelarObservacao() {
      this.disableFormObs = true;
      this.loadingCampos = false;
      this.setExame(this.exame);
      this.$refs.exameForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    formatHyphenToSlash(dateString) {
      if (!dateString) return "";
      try {
        // Verifica se a data está no formato esperado YYYY-MM-DD
        if (
          typeof dateString !== "string" ||
          !/^\d{4}-\d{2}-\d{2}$/.test(dateString)
        ) {
          console.warn("Data não está no formato YYYY-MM-DD:", dateString);
          return dateString;
        }

        // Separa a data em ano, mês e dia
        const [year, month, day] = dateString.split("-");
        // Retorna no formato DD/MM/YYYY
        return `${day}/${month}/${year}`;
      } catch (error) {
        console.error("Erro ao transformar formato da data:", error);
        return "";
      }
    },
    hideModal() {
      this.examesSelected = [];
      this.$refs["my-modal"].hide();
    },
    showMsgBoxCreate() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja Criar requisição para os exames selecionados?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.addExames();
          }
        });
    },
    editExame() {
      this.loading = true;
      this.$store
        .dispatch("exameModule/getById", this.exame.id)
        .then((response) => {
          this.exame = response;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar exames:", error);
          this.loading = false;
        });
    },
    deleteExame(item) {
      this.$bvModal
        .msgBoxConfirm(`Deseja realmente remover o exame ${item.exame}?`, {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.$store.dispatch("exameModule/delete", item.id).then((response) => { 
              this.showMessageSuccess(
                "Removido",
                "Exame removido com sucesso!",
              );
            })
            this.editExame()
          }
        });
    },
    addExames() {
      const obj = {
        exames: this.examesSelected.map((item) => item.value),
        id: this.exame.id
      }
      this.$store.dispatch("exameModule/addExames", obj).then((response) => {
        console.log(response)
        this.hideModal();
      });
    },
     async showModal() {
      this.examesSelected = [];
      this.$refs["my-modal"].show();
    },
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair do cadastro do exame?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setExame(this.exame);
      this.$refs.exameForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.exameForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch("exameModule/updateExame", this.exame.exames)
              .then((response) => {
                this.cancelar();
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Exame Fisico Editado com sucesso!",
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
    getExameData() {
      return this.exame;
    },
    setExame(data) {
      if (data) {
        this.exame = {
          id: data.id,
          ...this.exame,
          ...data,
        };
      }
    },
  },
};
</script>
